import mutate from 'js-core/js/apollo/mutations/mutate';
import invalidateQuery from 'js-core/js/apollo/mutations/invalidateQuery';

import CreateGrowerMutation from 'gql/mutations/Grower/CreateGrower.gql';
import UpdateGrowerMutation from 'gql/mutations/Grower/UpdateGrower.gql';
import DeleteGrowerMutation from 'gql/mutations/Grower/DeleteGrower.gql';

export default class{

    static create(input) {

        return mutate(CreateGrowerMutation, { input }, store => {

            invalidateQuery(store, 'allGrowers');
        });
    }

    static update(input) {

        return mutate(UpdateGrowerMutation, { input });
    }

    static delete(id) {

        return mutate(DeleteGrowerMutation, { id }, store => {

            invalidateQuery(store, 'allGrowers');
        });
    }
}
